import BaseEnum from '@linc-technologies/linced-common/enums/base-enum';

export default BaseEnum.create({
  values: [
    { value: 0, label: 'Unspecified' },
    { value: 1, label: 'Draft' },
    { value: 2, label: 'Pending Approval' },
    { value: 3, label: 'Approved' },
    { value: 4, label: 'Open to Caregivers' },
    { value: 5, label: 'Open to Staff' },
    { value: 6, label: 'Closed' },
    { value: 7, label: 'Complete' },
    { value: 8, label: 'Cancelled' },
  ],
});
